import { render, staticRenderFns } from "./auctionRecord.vue?vue&type=template&id=88547c2a&scoped=true&"
import script from "./auctionRecord.vue?vue&type=script&lang=js&"
export * from "./auctionRecord.vue?vue&type=script&lang=js&"
import style0 from "./auctionRecord.vue?vue&type=style&index=0&id=88547c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88547c2a",
  null
  
)

export default component.exports